import { Injectable } from '@angular/core';
import { ActiveToast, IndividualConfig, ToastrService } from 'ngx-toastr';

// Errors stay visible longer than the global 500ms default
@Injectable()
export class AppToastrService extends ToastrService {
  override error(
    message?: string,
    title?: string,
    override: Partial<IndividualConfig> = {}
  ): ActiveToast<any> {
    return super.error(message, title, { timeOut: 3000, ...override });
  }
}
